import type { Client } from 'models/flexible/Client';
import type { Group } from 'models/flexible/Group';

import { AICriteria, AICriteriaCategory, type AICriteriaCategoryOptions, type AICriteriaOptions } from './AICriteria';

export interface AICriteriaSetOptions {
  id?: string;
  type?: string;
  scopeableType?: string;
  scopeableId?: string;
  archived?: boolean;
  createdAt?: string;
  updatedAt?: string;
  scopeable?: any;
  client?: any;
  criteria?: AICriteriaOptions[];
  categories?: AICriteriaCategoryOptions[];
}

export class AICriteriaSet {
  id: string;
  type: string;
  scopeableType: string;
  scopeableId: string;
  archived: boolean;
  createdAt: Date | null;
  updatedAt: Date | null;
  scopeable?: Group;
  client?: Client;
  criteria: AICriteria[];
  categories: AICriteriaCategory[];

  constructor(options?: AICriteriaSetOptions) {
    this.id = options?.id ?? '';
    this.type = options?.type ?? '';
    this.scopeableType = options?.scopeableType ?? '';
    this.scopeableId = options?.scopeableId ?? '';
    this.archived = options?.archived ?? false;
    this.createdAt = options?.createdAt ? new Date(options.createdAt) : null;
    this.updatedAt = options?.updatedAt ? new Date(options.updatedAt) : null;
    this.scopeable = options?.scopeable;
    this.client = options?.client;
    this.criteria = (options?.criteria ?? []).map((c) => new AICriteria(c));
    this.categories = (options?.categories ?? []).map((c) => new AICriteriaCategory(c));
  }
}
